class ShadeFinderQuizSkintone extends window.BAO.CustomElement() {
  connectedCallback () {
    this.setupSkintoneChangeListeners()
    this.setupContinueListeners()
    this.setupBackListeners()
  }

  setupSkintoneChangeListeners () {
    const skintoneGroupRadioEl = document.querySelectorAll('.sec-QuizContent_SkintoneBlockRadioInput')

    skintoneGroupRadioEl.forEach((radioEl) => {
      radioEl.addEventListener('click', () => {
        const clickedSkintoneGroupEl = radioEl
        const clickedSkintoneGroupElValue = clickedSkintoneGroupEl.getAttribute('data-modelfit-skintone-group')
        const continueBtns = document.querySelectorAll('[data-modelfit-section-trigger]')

        continueBtns.forEach((continueBtn) => {
          continueBtn.setAttribute('data-modelfit-skintone-group', clickedSkintoneGroupElValue)
          continueBtn.removeAttribute('disabled')
        })
      })
    })
  }

  setupContinueListeners () {
    const continueBtns = document.querySelectorAll('[data-modelfit-section-trigger]')

    continueBtns.forEach((continueBtn) => {
      continueBtn.addEventListener('click', () => {
        document.querySelector('shade-finder-quiz-skintone').classList.remove('is-active')
        document.querySelector('shade-finder-quiz-modelfits').classList.add('is-active')

        const continueBtnSkintoneVal = continueBtn.getAttribute('data-modelfit-skintone-group')
        const modelfitGroupSkintoneGroupVal = document.querySelectorAll('.sec-QuizContent_Blocks-Grid')

        modelfitGroupSkintoneGroupVal.forEach((modelfitGroupEl) => {
          if (continueBtnSkintoneVal === modelfitGroupEl.getAttribute('data-skintone-group')) {
            modelfitGroupEl.classList.add('is-active')
            window.scrollTo(0, 0)
          } else {
            modelfitGroupEl.classList.remove('is-active')
          }
        })
      })
    })
  }

  setupBackListeners () {
    const backBtn = document.querySelector('[data-skintone-section-back-trigger]')

    backBtn.addEventListener('click', () => {
      document.querySelector('shade-finder-quiz-skintone').classList.remove('is-active')
      document.querySelector('shade-finder-quiz-start').classList.add('is-active')

      window.scrollTo(0, 0)
    })
  }
}

if (!customElements.get('shade-finder-quiz-skintone')) {
  customElements.define('shade-finder-quiz-skintone', ShadeFinderQuizSkintone)
}
